import { ReactComponent as ClockSvg } from '../../assets/icons/clock.svg';

export const ClockIcon: SvgIcon = (props) => {
    return <ClockSvg {...props} />;
};
